import Router from "Router";
import useCheckToken from "hooks/useCheckToken";
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-KGH8HPQF'
}

TagManager.initialize(tagManagerArgs);

function App() {
  const isLoading = useCheckToken();

  if (isLoading) return null;

  return <Router />;
}

export default App;
